export const PrivateConfig = {
    firebase : {
        apiKey : 'AIzaSyAqvcf9AHA8dFSWRWd2nLSf449i2q8fVB0',
        authDomain: 'odu-komban-ok.firebaseapp.com',
        databaseURL: 'https://odu-komban-ok.firebaseio.com',
        projectId: 'odu-komban-ok',
        storageBucket: 'odu-komban-ok.appspot.com',
        messagingSenderId: "209002783516"
    },
    google_maps : {
        apiKey : 'AIzaSyDiwb683dW2wbHkSLhkm01w_7t6r6jYkTQ',
    }
}